import {Component, Input, OnInit} from '@angular/core';
import {TramiteService} from "../../services/tramite.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfirmationService, MessageService} from "primeng/api";
import {FileUtilsService} from "../../../../shared/services/file-utils-service";
import {TramitesPrevios} from "../interfaces/formulario.interfaces";

@Component({
    selector: 'app-tramites-previos',
    templateUrl: './tramites-previos.component.html',
    styleUrl: './tramites-previos.component.scss',
    providers: [MessageService, ConfirmationService]
})
export class TramitesPreviosComponent implements OnInit {
    archivoBuffer: string | ArrayBuffer | null = null
    archivoSeleccionado: any = null;
    hashDelArchivo: any = null
    expediente: string = "";
    tramitesPrevios: TramitesPrevios[] = [
        {id: 1, nombre: 'Línea de construcción'},
        {id: 2, nombre: 'Calificación de lugar'},
        {id: 3, nombre: 'Factibilidad de descarga aguas lluvias'},
        {id: 4, nombre: 'Revisión vial y zonificación'},
        {id: 5, nombre: 'Permiso de construcción'}
    ];
    @Input("pivoteTramitesPrevios") pivoteTramitesPrevios!: number;
    constructor(public tramite: TramiteService,
                private router: Router, private route: ActivatedRoute,
                private messageService: MessageService, protected fileUtilsService: FileUtilsService) {
    }
    ngOnInit() {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.filterTramitesPrevios(this.tramitesPrevios);
    }
    async onFileUpload(event: any, cargaArchivos: any) {
        let file: [] = event.files;
        let result = await this.fileUtilsService.calcularHash(file);
        this.archivoSeleccionado = await this.fileUtilsService.file;
        this.archivoBuffer = this.fileUtilsService.fileBuffer;
        this.hashDelArchivo = await this.fileUtilsService.hash;
        const reader = new FileReader();
        reader.readAsDataURL(event.files[0]);
        reader.onload = () => {
            this.archivoBuffer = reader.result
        };
        if (event == null) {
            this.messageService.add({
                severity: 'error',
                summary: 'Archivo no cargado',
                detail: 'Fallo de carga de archivo'
            });
            cargaArchivos.clear(); //limpiando para cargar otro archivos
            return;
        }
        if (event.files.length == 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Archivo no cargado',
                detail: 'Fallo de carga de archivo'
            });
            cargaArchivos.clear(); //limpiando para cargar otro archivos
            return;
        }
        if (result == 3) {
            this.messageService.add({
                severity: 'error',
                summary: 'Ocurrio un error',
                detail: 'Falla al cargar el archivo'
            });
            cargaArchivos.clear(); //limpiando para cargar otro archivos
            return;
        } else if (result == 1) {
            console.log('Exito se cargo el archivo en memoria');
            console.log(file)
            //this.onFileSelected(true,cargaArchivos,idRequisito);
        } else if (result == 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Archivo no cargado',
                detail: 'Fallo de carga de archivo'
            });
            cargaArchivos.clear(); //limpiando para cargar otro archivos
        }
        console.log("Resultado verificacion:-> ", result);
    }
    filterTramitesPrevios(items: TramitesPrevios[]) {
        if (items.length == 0) {
            return [];
        }
        if (this.pivoteTramitesPrevios == 1) {
            this.tramitesPrevios = items.filter(tramite => tramite.id !== 5 && tramite.nombre !== 'Permiso de construcción');
            return this.tramitesPrevios;
        } else if (this.pivoteTramitesPrevios == 2) {
            this.tramitesPrevios;
        }
        return;
    }
}
